import { useTranslation } from "@sagot/i18n";
import { Button, Dialog, DialogContent } from "@sagot/ui";
import { useFormatters, type InvoiceOut } from "../shared";
import { GatewayChooser, useGatewayChoice, type CheckoutChoiceBody } from "./gateway-chooser";
import { TestModeNotice } from "./test-mode-notice";

interface PayInvoiceDialogProps {
  invoice: InvoiceOut;
  gateways: readonly string[];
  paying: boolean;
  onPay: (body: CheckoutChoiceBody) => void;
  onClose: () => void;
}

/** USD invoices: the payer picks Card (Stripe) or PayPal before the hosted checkout. */
export function PayInvoiceDialog({ invoice, gateways, paying, onPay, onClose }: PayInvoiceDialogProps) {
  const { t } = useTranslation();
  const fmt = useFormatters();
  const choice = useGatewayChoice(gateways);
  return (
    <Dialog open onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent
        title={t("billing.invoices.payTitle", { number: invoice.number })}
        closeLabel={t("common.close")}
        className="max-w-md"
        footer={
          <>
            <Button variant="secondary" onClick={onClose}>
              {t("common.cancel")}
            </Button>
            <Button loading={paying} onClick={() => { onPay(choice.body); }}>
              {t("billing.invoices.payAmount", { amount: fmt.moneyExact(invoice.amount_due, invoice.currency) })}
            </Button>
          </>
        }
      >
        <div className="space-y-3">
          <GatewayChooser state={choice} />
          <TestModeNotice gateways={[choice.gateway]} />
        </div>
      </DialogContent>
    </Dialog>
  );
}
